
namespace Gamification.Gamification {
    export class TipologieRisorseColumns {
        static columnsKey = 'Gamification.TipologieRisorse';
    }
}